import { createContext, useContext } from 'react';
import type { ObjectRecord } from '@/services/db/object/entity';
import type { ObjectType } from '@/services/db/object-type/entity';

export type ObjectDetailTab = 'attributes' | 'relationships' | 'activity';

export type ObjectDetailContextValue = {
  record: ObjectRecord;
  objectType: ObjectType;
  workspaceId: number;
  canConfigureObjects: boolean;
  canCreateRelationships: boolean;
  canDelete: boolean;
  canExport: boolean;
  isMultiIdentifier: boolean;
  shouldRedactCreatedAt: boolean;
  hrefs: {
    overview: string;
    /** Ember-served tab URLs until FPS-2778/2786/2795 migrate them. */
    tabs: Record<ObjectDetailTab, string>;
    attributesEdit: string;
    typeList: string;
  };
};

const ObjectDetailContext = createContext<ObjectDetailContextValue | null>(null);

export const ObjectDetailProvider = ObjectDetailContext.Provider;

export function useObjectDetail(): ObjectDetailContextValue {
  const value = useContext(ObjectDetailContext);
  if (value == null) {
    throw new Error('useObjectDetail must be used within the object detail route');
  }
  return value;
}
